import { createIcon } from '@chakra-ui/icons';

export const Udemy = createIcon({
  displayName: 'Udemy',
  viewBox: '0 0 13 24',
  d: 'M6.19 0L0 3.573V7.147L6.189 3.573L12.38 7.147V3.573L6.19 0ZM0 10.148V18.292C0 20.142 0.589 21.535 1.741 22.526C2.893 23.517 4.367 24 6.163 24C7.959 24 9.432 23.518 10.611 22.526C11.79 21.535 12.379 20.087 12.379 18.212V10.148H9.137V17.998C9.137 20.034 7.628 21.053 6.189 21.053C4.761 21.053 3.242 20.062 3.242 18.026V10.148H0Z',
});
